<app-page headline="Warehouse Management Systems">
  <DataTable
    [datasource]="wms"
    [columns]="erpColumns"
    (rowClick)="handleRowClick($event)"
  >
  </DataTable>
</app-page>

<Dialog [show]="showDialog()" (showing)="showDialog.set($event)">
  <DialogHeader>Details</DialogHeader>
  <div stack-layout padding="md" gap="sm" [width]="300">
    <app-display-value label="Code">
      {{ selectedWMS()?.code }}
    </app-display-value>
    <app-display-value label="Name">
      {{ selectedWMS()?.name }}
    </app-display-value>
  </div>
</Dialog>
